exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "form input.largeText-d736ea4a{font-size:16px}\n", ""]);

// Exports
exports.locals = {
	"largeText": "largeText-d736ea4a"
};